export default {
  baseUrl: 'https://api.615autorental.com/api/',
}
